import Vue from "vue";

export const TaskCodesState = {
  task_codes: null,
  tasks_codes: []
};

export const TaskCodesGetters = {
  taskCodes: state => {
    return state.task_codes;
  },
  tasksCodes: state => {
    return state.tasks_codes;
  }

}

export const TaskCodesMutations = {

  setTaskCodes: (state, data) => {
    if (data) {
      const index = state.tasks_codes.findIndex(
        i => Number(i.id) === Number(data.id)
      );
      if (index > -1) {
        const arr = [...state.tasks_codes];
        arr[index] = data;
        Vue.set(state, "tasks_codes", arr);
      }
    }
    Vue.set(state, "task_codes", data);
  },

  setTasksCodes: (state, data) => {
    const sortByPosition = (a, b) => {
      if (a.position < b.position) return -1;
      if (a.position > b.position) return 1;
      return 0;
    };
    data.sort(sortByPosition);
    Vue.set(state, "tasks_codes", data);
  },

  addTaskCode: (state, data) => {
    Vue.set(state, "tasks_codes", [...state.tasks_codes, data]);
  },

  removeTaskCode: (state, data) => {
    const arr = state.tasks_codes.filter(i => Number(i.id) !== Number(data.id));
    Vue.set(state, "tasks_codes", arr);
  }

}

export const TaskCodesActions = {
  async getTasksCodes({ commit, dispatch }, data = {}) {
    try {
      const res = await Vue.axios.secured.get("/api/v1/task_codes");
      commit("setTasksCodes", res.data);
      return { success: true, data: res.data };
    } catch (error) {
      const err = error.response && error.response.data;
      const message = err || "Unable to fetch tasks from server.";
      dispatch("showToast", { message, type: "error" });
      return { success: false, data: null };
    }
  },

  async getTaskCodes({ commit, dispatch }, id) {
    try {
      const res = await Vue.axios.secured.get(`/api/v1/task_codes/${id}`);
      commit("setTaskCodes", res.data);
      return { success: true, data: res.data };
    } catch (error) {
      const err = error.response && error.response.data;
      const message = err || "Unable to fetch task from server.";
      dispatch("showToast", { message, type: "error" });
      return { success: false, data: null };
    }
  },

  async createTaskCode({ commit, dispatch }, data = {}) {
    try {
      const res = await Vue.axios.secured.post("/api/v1/task_codes", { task_code: data.taskCode });
      commit("addTaskCode", res.data);
      const message = `Task code has been successfully added.`;
      dispatch("showToast", { message, type: "success" });
      return { success: true, data: res.data };
    } catch (error) {
      const err = error.response && error.response.data;
      const message = err || "Unable to create task code.";
      dispatch("showToast", { message, type: "error" });
      return { success: false, data: null };
    }
  },

  async updateTaskCode({ commit, dispatch }, data) {
    const {taskCode} = data
    try {
      const res = await Vue.axios.secured.patch(`/api/v1/task_codes/${taskCode.id}`, { task_code: taskCode });
      commit("setTaskCodes", res.data);
      const message = `Task code ${res.data.code} has been successfully updated.`;
      dispatch("showToast", { message, type: "success" });
      return { success: true, data: res.data };
    } catch (error) {
      const err = error.response && error.response.data;
      const message = err || "Unable to update task code.";
      dispatch("showToast", { message, type: "error" });
      return { success: false, data: null };
    }
  },

  async deleteTaskCode({ commit, dispatch }, data = {}) {
    const {taskCode} = data
    try {
      await Vue.axios.secured.delete(`/api/v1/task_codes/${taskCode.id}`);
      commit("removeTaskCode", { id: taskCode.id });
      const message = `Task code ${taskCode.code} has been successfully removed.`;
      dispatch("showToast", { message, type: "success" });
      return { success: true };
    } catch (error) {
      const err = error.response && error.response.data;
      const message = err || "Unable to delete task code.";
      dispatch("showToast", { message, type: "error" });
      return { success: false };
    }
  },

  moveTaskCode: async ({ dispatch }, { taskCode }) => {
    try {
      await Vue.axios.secured.patch(`/api/v1/task_codes/${taskCode.id}`, { task_code: taskCode });
      dispatch("getTasksCodes");
      const message = `Task code ${taskCode.code} has been successfully updated.`;
      dispatch("showToast", { message, type: "success" });
    } catch (error) {
      const message = (error.response && error.response.data) || "Unable to update task code.";
      dispatch("showToast", { message, type: "error" });
    }
  }

}



// WEBPACK FOOTER //
// ./src/store/modules/tasks-codes.js